<template>
    <div>

        <!-- 操作-->

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
            <el-form :inline="true" :model="topForm" ref="topForm">
                <el-form-item >
                    <el-input v-model="topForm.resourcesName" placeholder="素材名称" ></el-input>
                </el-form-item>
                <!-- tag  ent ---------------------------------------------------->
                <el-form-item>
                    <el-button type="primary" class="" @click="getData" icon="search":loading="loading">查询</el-button>
                </el-form-item>


                <el-form-item >
                    <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>

            </el-form>
        </el-col>
        <!-- 表格分页-->
        <div class="block">
            <el-table   :data="tableData"  ref="multipleTable"  border  style="width: 100%;" v-loading="loading2"
                      element-loading-text="拼命加载中"    >

                <el-table-column   width="355" label="图片" style="text-align: center" >
                <template scope="scope"> <!--<el-checkbox v-model="scope.row.checked">备选项</el-checkbox>-->
                    <img :src="scope.row.download_url"  style="width: 60%">
                </template>
                </el-table-column>
                <el-table-column prop="resources_name" label="名称" > </el-table-column>

                <el-table-column label="操作" width="230px">
                    <template scope="scope">
                        <el-button  size="small" @click="affirmResources(scope.row)" >添加</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>



        <div class="block">

            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>

    </div>

</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    import ElInput from "../../../../node_modules/element-ui/packages/input/src/input.vue";
    export  default{
        name: "MaterialSelect",
        components: {
            ElInput,
            ElFormItem},
        props:
            ['feature' ],
        data(){

            return {
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据


                //参数设置
                url: this.admin_host+"/material/api/find/list", // 分页查询请求路径
                topForm:{
                    resourcesName:'',
                    resourcesTypeId:'',
                    tagId: '',
                },
                checked:true,
                multipleSelection:[],
                materiaTypeList:[ ],
                loading:false,
                loading2:false,
                isTableSelectAll:false,
                initOrgInfo:{
                    level:'',
                    orgId:[]
                },
                /*弹窗选择*/
                /*弹窗内容选择*/
                btnAll:{
                    btn_0211:true,
                    btn_0212:true,
                    btn_0213:true,
                    btn_0214:true,
                    btn_0216:true,
                },
                //checkbox
                checkboxlength:0,
                //tag======================
                taglist: [],
                //tag end======================
                title:"",
                tenantId:"",
                labelTypeId:"material",
            }


        },
        created(){
           var tenantId=this.getcookie("storeId");
           this.tenantId=tenantId;
            this.getData();
        },

        methods: {


            handleSizeChange(val){
              //  console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            getData(){
                //数据请求

                this.loading2 = true;

                //异步请求
                var _this=this;
                this.$http.get(this.url+"?iDisplayStart="+this.activeNum+"&iDisplayLength="+this.pagesize+"&resourcesName="+this.topForm.resourcesName+
                    "&resourcesTypeId="+this.topForm.resourcesTypeId+"&feature="+this.feature+"&tenantId="+this.tenantId+"")
                    .then(response => {
                        if (response.status === 200) {
                            this.pagesCount = response.body.Data.count;
                            this.tableData = response.body.Data.resourcesList

                            this.loading2 = false;
                        }
                    },function(response){
                        this.loading2 = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            formatterTime(row, column) {
                var d = new Date(row.update_time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },


            /*重置*/
            resetForm(formName) {
             //   this.$refs[formName].resetFields();
                this.topForm.resourcesName='', this.topForm.resourcesTypeId=''

                this.getData();
            },
            /*确认资源*/
            affirmResources(row){
             //   this.$router.push( {name:"materialAdd",params:{}})
                this.$emit("listenAffirmResources",row.download_url)

            },



        }

    }

</script>


// WEBPACK FOOTER //
// MaterialSelect.vue?16a2da40